import React from "react";

function campaignInfluencer() {
  return <div>campaignInfluencer</div>;
}

export default campaignInfluencer;
